// src/components/BGP/BgpTabs.tsx
import React from "react"
import { Link, useLocation } from "react-router-dom"

export default function BgpTabs() {
    const location = useLocation()

    // Para "activar" el botón dependiendo de la ruta
    const isManagementActive = location.pathname === "/reflector/management/bgp/neighbors"
    const isStatusActive = location.pathname === "/reflector/management/bgp/status"

    return (
        <div
            className="
        inline-flex
        w-min
        rounded-md
        border border-semantic-border-secondary
        overflow-hidden
        mt-1
      "
        >
            {/* Management tab */}
            <Link
                to="/reflector/management/bgp/neighbors"
                className={`
          px-4 py-2
          text-sm font-medium
          transition-colors
          ${isManagementActive
                        ? "bg-white text-black"
                        : "bg-semantic-bg-primary text-semantic-text-secondary"
                    }
        `}
            >
                Neighbors
            </Link>

            {/* Status tab */}
            <Link
                to="/reflector/management/bgp/status"
                className={`
          px-4 py-2
          text-sm font-medium
          border-l border-semantic-border-secondary
          transition-colors
          ${isStatusActive
                        ? "bg-white text-black"
                        : "bg-semantic-bg-primary text-semantic-text-secondary"
                    }
        `}
            >
                Status
            </Link>
        </div>
    )
}
